import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Real results" className="border-y border-grape/10 bg-white/70" data-id="element-143" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-144" data-mp="2wvdtpr8o3u1o">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-145" data-mp="2nx1vp45h1tz7">
          {stats.map(s => <div key={s.label} className="text-center" style={{
          width: "148px",
          height: "72px"
        }} data-id="element-146" data-mp="2nz4vgfwff1h4">
              <dt className="font-display text-4xl font-black text-plum sm:text-5xl" style={{
            color: "#5B21B6"
          }} data-id="element-147" data-mp="2dyuhuu6hbs1f">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-148" data-mp="208inspqc3j7n">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}